const Form103SC = {
    stepName: {
        importantNotes: "重要提示",
        applicationInformation: "申请资料",
        collectionMeans: "收集电子联络方式",
        confirmation: "确认",
    },
    importantNotesContent: {
        statement: "本人已阅读、明白及同意上述条款及细则。",
        termsConditions: "本人理解申请人需要拥有「智方便+」帐户才能处理申请。",
    },

    note: {
        supervisorEmail: "(用作接收电子证书)",
        supervisorTel: "(用作通讯及接收手机短讯)",
        schoolCode: "(仅适用于已注册学校)",
        receiveSMSChecked:
            "本人证明在本回条内所填报的资料均属真确及完整。本人已细阅“个人资料收集声明”，亦明白教育局就学校注册及相关事宜，在有需要时会依据上述的电子联络方式，以手机短讯及/或电邮向本人发出电子通知(例如：申请获批时发出电子版本的“学校注册证明书或学校临时注册证明书”)。本人如不愿意接收手机短讯，会在下列方格内填上“√”号，否则将被视为愿意接收该些短讯。",
    },

    collectionMeans: {
        label: {
            schoolName: "学校名称",
            schoolAddress: "学校地址",
            supervisorTitle: "校监称谓",
            supervisorName: "校监姓名",
            supervisorEmail: "校监的电邮地址",
            supervisorTel: "校监的流动电话号码",
            schoolCode: "学校编号",
            receiveSMSChecked: "本人不愿意就学校注册及相关事宜接收手机短讯。",
            receiveSMSNo: "本人愿意就学校注册及相关事宜接收手机短讯。",
        },
        errorMsg: {
            receiveSMSChecked: "请输入一个有效的校监姓名",
            schoolCode: "学校编号必须为6位数",
        },
        option: {
            titleOption: {
                Mr: "先生",
                Miss: "小姐",
                Ms: "女士",
                Mrs: "太太",
            },
        },
    },
};

export default Form103SC;
